import { CSSProperties } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { TelegramStar } from '@/components/common/svg/telegram/TelegramStar.tsx';

type PurchaseItemProps = {
  style: CSSProperties;
  price: number;
  discountValue?: number;
  icon: JSX.Element;
  isBestDeal?: boolean;
};

const PurchaseItem = ({
  style,
  price,
  discountValue,
  icon,
  isBestDeal
}: PurchaseItemProps) => {
  const { t } = useTranslation();

  const isDiscountValue =
    typeof discountValue === 'number' && discountValue > 0;

  return (
    <motion.div
      style={{
        ...containerStyle,
        ...style
      }}
    >
      <div style={iconContainerStyle}>
        <div style={mainRowStyle}>
          <span style={totalPriceStyle}>
            {price}
            <TelegramStar
              style={{
                marginLeft: '4px',
                display: 'inline-block',
                verticalAlign: 'middle',
                position: 'relative',
                top: '-2px'
              }}
              height={18}
              width={18}
            />
          </span>

          <span style={dividerStyle}>/</span>

          <div style={iconWrapperStyle}>
            {icon}
            {isBestDeal && <span style={bestDealStyle}>BEST DEAL</span>}
          </div>
        </div>

        {isDiscountValue && (
          <span style={discountTextStyle}>
            {t('paywall.discount.save')} {discountValue}%
          </span>
        )}
      </div>
    </motion.div>
  );
};

const containerStyle: CSSProperties = {
  width: '100%',
  height: '40px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: '#FFF',
  position: 'relative'
};

const iconContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginLeft: '8px',
  gap: '2px'
};

const mainRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

const iconWrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

const discountTextStyle: CSSProperties = {
  color: '#A5A5A5',
  fontSize: '11px',
  fontWeight: '400'
};

const dividerStyle: CSSProperties = {
  color: '#ffffff',
  fontSize: '16px',
  fontWeight: '600'
};

const bestDealStyle: CSSProperties = {
  background: '#D16FD9',
  color: '#FFF',
  fontSize: '11px',
  fontWeight: '600',
  padding: '3px 6px',
  borderRadius: '16px'
};

const totalPriceStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: '500',
  color: '#fff',
  lineHeight: '16px'
};

export default PurchaseItem;
